import { render, staticRenderFns } from "./transfer-pop.vue?vue&type=template&id=62659232&"
import script from "./transfer-pop.vue?vue&type=script&lang=js&"
export * from "./transfer-pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports